var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"transition--fade","appear":""}},[(_vm.active)?_c('div',{staticClass:"inline-spinner"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }